import { render, staticRenderFns } from "./sumContentYear.vue?vue&type=template&id=be90d02e"
import script from "./sumContentYear.vue?vue&type=script&lang=js"
export * from "./sumContentYear.vue?vue&type=script&lang=js"
import style0 from "./sumContentYear.vue?vue&type=style&index=0&id=be90d02e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports